/**
 * booking-form.js
 * Multi-step booking form for Ekatē session products.
 *
 * Steps (dynamic — skipped if count = 0):
 *   1  Date selection
 *   2  Parent(s) details   — rendered based on session.amount_of_parents (0–2)
 *                            + child RRN block appended if session.rrn_kind is 'verplicht' or 'mogelijk'
 *   3  Review + submit
 */

// ─── DEV FLAGS ──────────────────────────────────────────────
const DEV_SHOW_ALL_STEPS = false;  // set false in production
const DEV_DUMMY_SUMMARY  = false;  // set false in production
// ─────────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', function () {
  // ─── OPEN BOOKING PANEL ──────────────────────────────────

  function collapseEl(el) {
    // Snapshot current height + margin so both animate away together
    var startH  = el.scrollHeight;
    var startMb = parseFloat(getComputedStyle(el).marginBottom) || 0;
    el.style.overflow     = 'hidden';
    el.style.height       = startH + 'px';
    el.style.marginBottom = startMb + 'px';
    el.style.transition   = 'height .4s ease-in-out, margin-bottom .4s ease-in-out';
    // Force reflow so the browser registers the starting values before we change them
    el.getBoundingClientRect();
    el.style.height       = '0';
    el.style.marginBottom = '0';
  }

  function expandEl(el) {
    el.style.overflow   = 'hidden';
    el.style.transition = 'height .4s ease-in-out';
    el.style.height     = el.scrollHeight + 'px';
    el.addEventListener('transitionend', function onDone() {
      el.removeEventListener('transitionend', onDone);
      el.style.height   = '';
      el.style.overflow = '';
    });
  }

  var bookingPanel = document.getElementById('boek-sessie');

  if (bookingPanel) {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-open-booking]');
      if (!trigger) return;
      e.preventDefault();

      var preselectHandle = trigger.dataset.preselectSession || null;

      function applyPreselect() {
        if (preselectHandle) {
          var radio = document.querySelector('.session-list__radio[value="' + preselectHandle + '"]');
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        bookingPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      // If panel is already visible, just pre-select and scroll — no re-animation
      if (bookingPanel.style.display === 'block' || bookingPanel.offsetParent !== null) {
        applyPreselect();
        return;
      }

      // Lock image height on desktop so it doesn't stretch with the booking panel
      var heroImage = document.querySelector('.session-detail__hero-image');
      if (heroImage && window.innerWidth >= 768) {
        var lockedH     = heroImage.offsetHeight;
        var lockedRatio = heroImage.offsetWidth / lockedH;
        heroImage.style.height    = lockedH + 'px';
        heroImage.style.alignSelf = 'flex-start';
        function onHeroResize() {
          heroImage.style.height = (heroImage.offsetWidth / lockedRatio) + 'px';
        }
        window.addEventListener('resize', onHeroResize);
      }

      // Elements to collapse
      var typeWrapper = document.getElementById('session-detail-type');
      var bodyWrapper = document.getElementById('session-detail-body');

      // if (typeWrapper) collapseEl(typeWrapper);
      if (bodyWrapper) collapseEl(bodyWrapper);

      // Expand panel (starts at height 0)
      bookingPanel.style.overflow   = 'hidden';
      bookingPanel.style.height     = '0';
      bookingPanel.style.display    = 'block';
      // Force reflow
      bookingPanel.getBoundingClientRect();
      bookingPanel.style.transition = 'height .4s ease-in-out';
      bookingPanel.style.height     = bookingPanel.scrollHeight + 'px';
      bookingPanel.addEventListener('transitionend', function onPanelDone() {
        bookingPanel.removeEventListener('transitionend', onPanelDone);
        bookingPanel.style.height   = '';
        bookingPanel.style.overflow = '';
        applyPreselect();
      });
    });
  }

  const form = document.getElementById('booking-form');
  if (!form) return;

  // ─── STATE ────────────────────────────────────────────────

  // stepOrder is computed after a session is chosen; always starts with 1, ends with 4.
  let stepOrder    = [1, 2, 3, 4];
  let stepIndex    = 0;           // index into stepOrder
  let selectedSession = null;

  function currentStep() { return stepOrder[stepIndex]; }
  const REVIEW_STEP = 3;

  // ─── STEP NAVIGATION ─────────────────────────────────────

  function showStep(step) {
    if (DEV_SHOW_ALL_STEPS) {
      form.querySelectorAll('.booking-form__step').forEach(function (el) {
        el.style.display = 'block';
        el.setAttribute('aria-hidden', 'false');
      });
      buildSummary();
      return;
    }

    // ── Clear any standing error ──
    const existingError = form.querySelector('.booking-form__error');
    if (existingError) existingError.remove();

    const card     = document.querySelector('.session-detail__card');
    const fromH    = card ? card.offsetHeight : null;
    const outgoing = form.querySelector('.booking-form__step[aria-hidden="false"]');

    // Lock card height immediately ONLY when there is an outgoing step,
    // so display:none on steps doesn't collapse it during the fade-out.
    // (On the very first showStep call the panel is hidden, so we must not lock.)
    if (card && fromH !== null && outgoing) {
      card.style.overflow = 'hidden';
      card.style.height   = fromH + 'px';
    }

    function doSwap() {
      // Hide all, reset any leftover fade styles
      form.querySelectorAll('.booking-form__step').forEach(function (el) {
        el.style.display    = 'none';
        el.style.opacity    = '';
        el.style.transition = '';
        el.setAttribute('aria-hidden', 'true');
      });

      // Show incoming at opacity 0 so we can fade it in
      const current = form.querySelector('[data-step="' + step + '"]');
      if (current) {
        current.style.opacity = '0';
        current.style.display = 'block';
        current.setAttribute('aria-hidden', 'false');
        if (step === REVIEW_STEP) buildSummary();
      }

      // Update nav buttons
      const btnPrev   = document.getElementById('btn-prev');
      const btnNext   = document.getElementById('btn-next');
      const btnSubmit = document.getElementById('btn-submit');
      btnPrev.style.display   = 'inline-block';
      var btnPrevSpan = btnPrev.querySelector('span') || btnPrev;
      btnPrevSpan.textContent = stepIndex === 0 ? 'Sluiten' : 'Vorige';
      btnNext.style.display   = step < REVIEW_STEP ? 'inline-block' : 'none';
      btnSubmit.style.display = step === REVIEW_STEP ? 'inline-block' : 'none';

      // Update step indicator dots
      form.querySelectorAll('.booking-form__step-dot').forEach(function (dot) {
        const dotStep = parseInt(dot.dataset.forStep, 10);
        dot.classList.toggle('active', dotStep === step);
        dot.classList.toggle('completed', dotStep < step);
      });

      // ── Animate card height (only when we locked it above) ──
      if (card && fromH !== null && outgoing) {
        card.getBoundingClientRect(); // force reflow so browser lays out new step first
        const toH = card.scrollHeight;
        if (toH !== fromH) {
          card.style.transition = 'height .35s ease-in-out';
          card.style.height     = toH + 'px';
          card.addEventListener('transitionend', function onCardDone(e) {
            if (e.propertyName !== 'height') return;
            card.removeEventListener('transitionend', onCardDone);
            card.style.height     = '';
            card.style.overflow   = '';
            card.style.transition = '';
          });
        } else {
          // Heights are equal — transitionend won't fire, clean up immediately
          card.style.height   = '';
          card.style.overflow = '';
        }
      }

      // ── Fade in new step (simultaneous with height animation) ──
      if (current) {
        current.getBoundingClientRect();
        current.style.transition = 'opacity .2s ease';
        current.style.opacity    = '1';
        current.addEventListener('transitionend', function onFadeIn(e) {
          if (e.propertyName !== 'opacity') return;
          current.removeEventListener('transitionend', onFadeIn);
          current.style.opacity    = '';
          current.style.transition = '';
        });
      }
    }

    // ── Fade out outgoing step, then swap ──
    if (outgoing) {
      outgoing.style.transition = 'opacity .2s ease';
      outgoing.style.opacity    = '0';
      outgoing.addEventListener('transitionend', function onFadeOut(e) {
        if (e.propertyName !== 'opacity') return;
        outgoing.removeEventListener('transitionend', onFadeOut);
        doSwap();
      });
    } else {
      doSwap();
    }
  }

  document.getElementById('btn-next').addEventListener('click', function (e) {
    e.preventDefault();
    if (!validateStep(currentStep())) return;
    stepIndex++;
    showStep(currentStep());
  });

  document.getElementById('btn-prev').addEventListener('click', function (e) {
    e.preventDefault();
    if (stepIndex === 0) {
      // Close booking panel and restore body content
      var bodyWrapper  = document.getElementById('session-detail-body');
      var bookingPanel = document.getElementById('boek-sessie');
      if (bookingPanel) {
        var fromH = bookingPanel.offsetHeight;
        bookingPanel.style.overflow   = 'hidden';
        bookingPanel.style.height     = fromH + 'px';
        bookingPanel.getBoundingClientRect();
        bookingPanel.style.transition = 'height .4s ease-in-out';
        bookingPanel.style.height     = '0';
        bookingPanel.addEventListener('transitionend', function onClose() {
          bookingPanel.removeEventListener('transitionend', onClose);
          bookingPanel.style.display    = 'none';
          bookingPanel.style.height     = '';
          bookingPanel.style.overflow   = '';
          bookingPanel.style.transition = '';
        });
      }
      if (bodyWrapper) expandEl(bodyWrapper);
      return;
    }
    stepIndex--;
    showStep(currentStep());
  });

  // ─── BUILD STEPS AFTER SESSION CHOSEN ────────────────────

  function buildStepOrder(amountParents, rrnKind) {
    const order = [1];
    const needsChildData = rrnKind === 'verplicht' || rrnKind === 'mogelijk';
    if (amountParents > 0 || needsChildData) order.push(2);
    order.push(3);
    return order;
  }

  // ─── RRN FIELD FORMATTER ─────────────────────────────────
  // Format: xx.xx.xx-xxx.xx  (11 digits + 3 separators = 14 chars max)

  function formatRRN(raw) {
    var d = raw.replace(/\D/g, '').slice(0, 11);
    var out = '';
    for (var i = 0; i < d.length; i++) {
      out += d[i];
      if ((i === 1 || i === 3) && i < d.length - 1) out += '.';
      else if (i === 5 && i < d.length - 1) out += '-';
      else if (i === 8 && i < d.length - 1) out += '.';
    }
    return out;
  }

  function initRRNField(input) {
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('maxlength', '15');
    input.addEventListener('input', function () {
      var start              = input.selectionStart;
      var oldVal             = input.value;
      var digitsBeforeCursor = oldVal.slice(0, start).replace(/\D/g, '').length;
      var newVal             = formatRRN(oldVal);
      if (input.value === newVal) return;
      input.value = newVal;
      // Restore cursor at the same digit position
      var count = 0, newCursor = newVal.length;
      for (var i = 0; i < newVal.length; i++) {
        if (/\d/.test(newVal[i])) count++;
        if (count === digitsBeforeCursor) { newCursor = i + 1; break; }
      }
      if (digitsBeforeCursor === 0) newCursor = 0;
      input.setSelectionRange(newCursor, newCursor);
    });
  }

  function initRRNFields() {
    form.querySelectorAll('[data-rrn]').forEach(function (input) {
      initRRNField(input);
    });
  }

  // ─── RENDER PARENT FIELDS ────────────────────────────────

  function renderParents(count, rrnKind) {
    const container = document.getElementById('parents-container');
    container.innerHTML = '';

    for (let i = 1; i <= count; i++) {
      const prefix = 'parent_' + i + '_';
      const idPfx  = 'parent-' + i + '-';

      // Heading: single parent → "Jouw gegevens", multiple → "Ouder 1 / Ouder 2"
      const heading = count === 1 ? 'Jouw gegevens' : 'Ouder ' + i;

      const block = document.createElement('div');
      block.className = 'booking-form__parent-entry';
      block.dataset.parentIndex = i;
      block.innerHTML =
        '<h3 class="booking-form__step-title h2 mb-4">' + heading + '</h3>' +

        '<div class="booking-form__field">' +
          '<label for="' + idPfx + 'firstname">Voornaam</label>' +
          '<input type="text" id="' + idPfx + 'firstname" name="' + prefix + 'firstname" placeholder="Voornaam" autocomplete="given-name" required>' +
        '</div>' +

        '<div class="booking-form__field">' +
          '<label for="' + idPfx + 'lastname">Achternaam</label>' +
          '<input type="text" id="' + idPfx + 'lastname" name="' + prefix + 'lastname" placeholder="Achternaam" autocomplete="family-name" required>' +
        '</div>' +

        '<div class="booking-form__field">' +
          '<label for="' + idPfx + 'dob">Geboortedatum</label>' +
          '<input type="date" id="' + idPfx + 'dob" name="' + prefix + 'dob" required>' +
        '</div>' +

        // Only show email/phone/GDPR on the first parent block
        (i === 1 ?
          '<div class="booking-form__field">' +
            '<label for="' + idPfx + 'email">E-mail</label>' +
            '<input type="email" id="' + idPfx + 'email" name="' + prefix + 'email" placeholder="hallo@ekate.be" autocomplete="email" required>' +
          '</div>' +
          '<div class="booking-form__field">' +
            '<label for="' + idPfx + 'phone">Telefoon</label>' +
            '<input type="tel" id="' + idPfx + 'phone" name="' + prefix + 'phone" placeholder="+32 123 45 67 89" autocomplete="tel" required>' +
          '</div>'
        : '') +

        '<div class="booking-form__field">' +
          '<label class="flex flex-row items-center" for="' + idPfx + 'rrn">Rijksregisternr.' +
            '<span class="booking-form__field-tooltip">' +
              '<span class="booking-form__field-tooltip-icon">?</span>' +
              '<span class="booking-form__field-tooltip-text">Uw rijksregisternummer is nodig voor de administratieve verwerking van uw therapieafspraak. Uw gegevens worden veilig bewaard en kunnen op verzoek worden verwijderd.</span>' +
            '</span>' +
          '</label>' +
          '<input type="text" id="' + idPfx + 'rrn" name="' + prefix + 'rrn"' +
            ' placeholder="00.00.00-000.00" inputmode="numeric" maxlength="15" autocomplete="off" data-rrn required>' +
        '</div>' +

        // GDPR only once, on last parent block
        (i === count ?
          '<div class="booking-form__field booking-form__field--checkbox">' +
            '<label>' +
              '<input type="checkbox" name="gdpr_consent" required>' +
              '<span>Ik ga akkoord met de <a href="/policies/privacy-policy" target="_blank" rel="noopener">verwerking van mijn gegevens</a>, inclusief rijksregisternummer. Mijn e-mailadres mag gebruikt worden voor sessie-herinneringen en nieuwsbrieven van ekatē.</span>' +
            '</label>' +
          '</div>'
        : '');

      container.appendChild(block);
    }

    // ─ Child RRN block ─────────────────────────────────────
    if (rrnKind === 'verplicht' || rrnKind === 'mogelijk') {
      const isChildRequired = rrnKind === 'verplicht';
      const childBlock = document.createElement('div');
      childBlock.className = 'booking-form__child-rrn-section mt-8';
      if (!isChildRequired) childBlock.dataset.optionalChild = 'true';
      childBlock.innerHTML =
        '<div class="booking-form__child-header"><h4>Gegevens van je kind</h4></div>' +
        '<p class="booking-form__step-intro text-sm mb-4">Indien je een ouder bent, zijn we om administratieve doeleinden vereist om het rijksregisternummer op te nemen van je kind. Indien je geen ouder bent, mag je dit veld openlaten.</p>' +
        '<div class="booking-form__field">' +
          '<label class="flex flex-row items-center">Rijksregisternr. kind' +
            '<span class="booking-form__field-tooltip">' +
              '<span class="booking-form__field-tooltip-icon">?</span>' +
              '<span class="booking-form__field-tooltip-text">Het rijksregisternummer van uw kind is nodig voor de administratieve verwerking van de therapieafspraak. Deze gegevens worden veilig bewaard en kunnen op verzoek worden verwijderd.</span>' +
            '</span>' +
          '</label>' +
          '<input type="text" name="child_rrn" placeholder="00.00.00-000.00" inputmode="numeric" maxlength="15" autocomplete="off" data-rrn' +
          (isChildRequired ? ' required' : '') + '>' +
        '</div>';
      container.appendChild(childBlock);
    }
  }

  // ─── CALENDAR ────────────────────────────────────────────
  //
  // Reads the hidden radio inputs rendered by Liquid, groups sessions
  // by date, and renders a navigable month-grid calendar.
  // On day/slot selection it programmatically checks the right radio,
  // which fires the 'change' event and triggers all existing downstream
  // logic unchanged.

  (function initCalendar() {
    const mount = document.getElementById('cal-mount');
    if (!mount) return;                          // no sessions → empty state shown by Liquid

    // ── 1. Parse all hidden radio inputs into a date map ──────────

    // sessionMap: { "YYYY-MM-DD": [ radioInput, … ] }
    const sessionMap = {};

    document.querySelectorAll('#cal-radios input[type="radio"]').forEach(function (radio) {
      const date = radio.dataset.date;           // "YYYY-MM-DD"
      if (!date) return;
      if (!sessionMap[date]) sessionMap[date] = [];
      sessionMap[date].push(radio);
    });

    if (!Object.keys(sessionMap).length) return;

    // ── 2. Calendar state ─────────────────────────────────────────

    const today     = new Date();
    today.setHours(0, 0, 0, 0);

    // Open on the earliest month that has a session
    const allDates    = Object.keys(sessionMap).sort();
    let calYear       = today.getFullYear();
    let calMonth      = today.getMonth();        // 0-based
    let activeDateKey = null;                    // currently highlighted date

    const MONTHS_NL = [
      'Januari','Februari','Maart','April','Mei','Juni',
      'Juli','Augustus','September','Oktober','November','December'
    ];
    const DAYS_NL = ['Ma','Di','Wo','Do','Vr','Za','Zo'];

    // ── 3. Render ─────────────────────────────────────────────────

    function render() {
      mount.innerHTML = '';

      // ─ Header ─
      const header = document.createElement('div');
      header.className = 'cal__header';
      header.innerHTML =
        '<button type="button" class="cal__nav cal__nav--prev" aria-label="Vorige maand">&#8249;</button>' +
        '<span class="cal__title">' +
          '<strong>' + MONTHS_NL[calMonth] + '</strong>' +
          ' <span class="cal__year">' + calYear + '</span>' +
        '</span>' +
        '<button type="button" class="cal__nav cal__nav--next" aria-label="Volgende maand">&#8250;</button>';
      mount.appendChild(header);

      // ─ Weekday labels ─
      const labels = document.createElement('div');
      labels.className = 'cal__weekdays';
      DAYS_NL.forEach(function (d) {
        const cell = document.createElement('span');
        cell.className = 'cal__weekday';
        cell.textContent = d;
        labels.appendChild(cell);
      });
      mount.appendChild(labels);

      // ─ Day grid ─
      const grid = document.createElement('div');
      grid.className = 'cal__grid';

      // First day of the month — shift so Monday = col 0
      const firstOfMonth = new Date(calYear, calMonth, 1);
      let startDow = firstOfMonth.getDay();      // 0=Sun … 6=Sat
      startDow = (startDow === 0) ? 6 : startDow - 1;   // → Mon-based (0–6)

      const daysInMonth = new Date(calYear, calMonth + 1, 0).getDate();

      // Empty cells before day 1
      for (let i = 0; i < startDow; i++) {
        const blank = document.createElement('div');
        blank.className = 'cal__day cal__day--empty';
        grid.appendChild(blank);
      }

      // Day cells
      for (let d = 1; d <= daysInMonth; d++) {
        const mm  = String(calMonth + 1).padStart(2, '0');
        const dd  = String(d).padStart(2, '0');
        const key = calYear + '-' + mm + '-' + dd;
        const dt  = new Date(key + 'T00:00:00');

        const cell = document.createElement('button');
        cell.type  = 'button';
        cell.textContent = d;

        const sessions  = sessionMap[key] || [];
        const available = sessions.filter(function (r) {
          return r.dataset.cancelled !== 'true' && r.dataset.bookingClosed !== 'true' && parseInt(r.dataset.spotsLeft, 10) > 0;
        });
        const cancelled = sessions.length > 0 && sessions.every(function (r) {
          return r.dataset.cancelled === 'true';
        });
        const full = sessions.length > 0 && !available.length && !cancelled;
        const isPast = dt < today;

        if (!sessions.length || isPast) {
          cell.className = 'cal__day cal__day--inactive';
          cell.disabled  = true;
        } else if (cancelled) {
          cell.className = 'cal__day cal__day--cancelled';
          cell.disabled  = true;
          cell.title     = 'Geannuleerd';
        } else if (full) {
          cell.className = 'cal__day cal__day--full';
          cell.disabled  = true;
          cell.title     = 'Volzet';
        } else {
          cell.className = 'cal__day cal__day--available';
          cell.dataset.dateKey = key;
          if (key === activeDateKey) cell.classList.add('cal__day--selected');
        }

        grid.appendChild(cell);
      }

      mount.appendChild(grid);

      // ─ Time slot panel (shown when a date is active) ─
      if (activeDateKey && sessionMap[activeDateKey]) {
        mount.appendChild(buildSlotPanel(activeDateKey));
      }

      // ─ Nav button states ─
      const btnPrev = mount.querySelector('.cal__nav--prev');
      const btnNext = mount.querySelector('.cal__nav--next');

      // Disable prev if we're already on the earliest available month
      const earliestMonth = new Date(allDates[0] + 'T00:00:00');
      if (calYear < earliestMonth.getFullYear() ||
          (calYear === earliestMonth.getFullYear() && calMonth <= earliestMonth.getMonth())) {
        btnPrev.disabled = true;
      }

      // Disable next if no sessions exist beyond this month
      const latestMonth = new Date(allDates[allDates.length - 1] + 'T00:00:00');
      if (calYear > latestMonth.getFullYear() ||
          (calYear === latestMonth.getFullYear() && calMonth >= latestMonth.getMonth())) {
        btnNext.disabled = true;
      }

      // ─ Event listeners ─
      btnPrev.addEventListener('click', function () {
        calMonth--;
        if (calMonth < 0) { calMonth = 11; calYear--; }
        render();
      });

      btnNext.addEventListener('click', function () {
        calMonth++;
        if (calMonth > 11) { calMonth = 0; calYear++; }
        render();
      });

      grid.addEventListener('click', function (e) {
        const btn = e.target.closest('.cal__day--available');
        if (!btn) return;
        activeDateKey = btn.dataset.dateKey;
        const sessions = sessionMap[activeDateKey] || [];
        const available = sessions.filter(function (r) {
          return r.dataset.cancelled !== 'true' && r.dataset.bookingClosed !== 'true' && parseInt(r.dataset.spotsLeft, 10) > 0;
        });
        // Auto-select if only one slot; otherwise show the panel
        if (available.length === 1) {
          selectSession(available[0]);
        }
        render();
      });
    }

    // ── 4. Time slot panel (multiple sessions on same day) ────────

    function buildSlotPanel(dateKey) {
      const sessions = (sessionMap[dateKey] || []).filter(function (r) {
        return r.dataset.cancelled !== 'true' && r.dataset.bookingClosed !== 'true' && parseInt(r.dataset.spotsLeft, 10) > 0;
      });

      const panel = document.createElement('div');
      panel.className = 'cal__slot-panel';

      // Date heading
      const dt = new Date(dateKey + 'T00:00:00');
      const dayName = dt.toLocaleDateString('nl-BE', { weekday: 'long', day: 'numeric', month: 'long' });
      const heading = document.createElement('p');
      heading.className = 'cal__slot-heading';
      heading.textContent = dayName.charAt(0).toUpperCase() + dayName.slice(1);
      panel.appendChild(heading);

      // Slot buttons
      const slotRow = document.createElement('div');
      slotRow.className = 'cal__slot-row';

      sessions.forEach(function (radio) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cal__slot-btn';
        if (radio.checked) btn.classList.add('cal__slot-btn--selected');
        btn.textContent = radio.dataset.timeStart + ' – ' + radio.dataset.timeEnd;
        btn.dataset.radioId = radio.id;

        btn.addEventListener('click', function () {
          selectSession(radio);
          render();
        });

        slotRow.appendChild(btn);
      });

      panel.appendChild(slotRow);

      // Confirmation strip (shown after a slot is selected)
      const checkedRadio = sessions.find(function (r) { return r.checked; });
      if (checkedRadio) {
        const spotsLeft = parseInt(checkedRadio.dataset.spotsLeft, 10);
        const confirm   = document.createElement('div');
        confirm.className = 'cal__slot-confirm';
        confirm.innerHTML =
          '<span class="cal__slot-confirm-time">' +
            checkedRadio.dataset.timeStart + ' – ' + checkedRadio.dataset.timeEnd +
          '</span>' +
          '<span class="cal__slot-confirm-meta">' +
            escapeHTML(checkedRadio.dataset.location) +
            ' &nbsp;·&nbsp; ' +
            (spotsLeft === 1 ? 'Nog 1 plaats' : 'Nog ' + spotsLeft + ' plaatsen') +
          '</span>' +
          '<span class="cal__slot-confirm-price">€' + escapeHTML(checkedRadio.dataset.price) + '</span>';
        panel.appendChild(confirm);
      }

      return panel;
    }

    // ── 5. Select a session — checks the radio + fires 'change' ───

    function selectSession(radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // ── 6. Boot ───────────────────────────────────────────────────
    // Jump to the first month that has upcoming available sessions,
    // highlight the date, and pre-select if there is only one slot.
    for (var _k = 0; _k < allDates.length; _k++) {
      var _key   = allDates[_k];
      var _dt    = new Date(_key + 'T00:00:00');
      if (_dt < today) continue;
      var _avail = (sessionMap[_key] || []).filter(function (r) {
        return r.dataset.cancelled !== 'true' && r.dataset.bookingClosed !== 'true' && parseInt(r.dataset.spotsLeft, 10) > 0;
      });
      if (!_avail.length) continue;
      activeDateKey = _key;
      calYear  = _dt.getFullYear();
      calMonth = _dt.getMonth();
      if (_avail.length === 1) selectSession(_avail[0]);
      break;
    }

    render();
  }());

  // ─── SESSION SELECTION → BUILD STEPS ─────────────────────

  // When a session radio is selected, immediately build the parent/child fields
  // so they're ready when the user navigates to those steps.
  form.addEventListener('change', function (e) {
    if (e.target.name !== 'session_date') return;

    // Toggle active class on list-style labels
    form.querySelectorAll('.session-list__item').forEach(function (label) {
      label.classList.remove('active');
    });
    var parentLabel = e.target.closest('.session-list__item');
    if (parentLabel) parentLabel.classList.add('active');

    const selected = e.target;
    const amountParents = parseInt(selected.dataset.amountParents, 10) || 0;
    const rrnKind       = (selected.dataset.rrnKind || 'niet van toepassing').toLowerCase();

    selectedSession = {
      handle:          selected.value,
      price:           selected.dataset.price,
      date:            selected.dataset.date,
      timeStart:       selected.dataset.timeStart,
      timeEnd:         selected.dataset.timeEnd,
      location:        selected.dataset.location,
      spotsLeft:       parseInt(selected.dataset.spotsLeft, 10),
      amountParents:   amountParents,
      rrnKind:         rrnKind,
      isTraject:       selected.dataset.isTraject === 'true',
      trajectSessions: selected.dataset.trajectSessions
                         ? JSON.parse(selected.dataset.trajectSessions)
                         : null
    };

    console.log('[booking-form] session selected | rrnKind:', JSON.stringify(rrnKind), '| amountParents:', amountParents);

    stepOrder = buildStepOrder(amountParents, rrnKind);

    const needsStep2 = amountParents > 0 || rrnKind === 'verplicht' || rrnKind === 'mogelijk';
    if (needsStep2) renderParents(amountParents, rrnKind);
    initRRNFields();
  });

  // ─── VALIDATION ──────────────────────────────────────────

  function validateStep(step) {
    if (step === 1) {
      if (!selectedSession) {
        showError('Kies een datum om verder te gaan.');
        return false;
      }
      return true;
    }

    if (step === 2) {
      const stepEl = form.querySelector('[data-step="' + step + '"]');
      const fields = stepEl.querySelectorAll('[required]');
      for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        if (field.type === 'checkbox' && !field.checked) {
          field.focus();
          showError('Bevestig je akkoord met de privacyverklaring.');
          return false;
        }
        if (field.type !== 'checkbox' && !field.value.trim()) {
          field.focus();
          showError('Vul alle verplichte velden in.');
          return false;
        }
      }
      // Email + phone format check (only on step 2 where these fields live)
      if (step === 2) {
        const email = stepEl.querySelector('input[type="email"]');
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
          email.focus();
          showError('Vul een geldig e-mailadres in.');
          return false;
        }
        const phone = stepEl.querySelector('input[type="tel"]');
        if (phone && !/^\+?[\d\s\-().]{7,20}$/.test(phone.value.trim())) {
          phone.focus();
          showError('Vul een geldig telefoonnummer in.');
          return false;
        }
      }
      // RRN digit count check — skip optional child blocks that are entirely empty
      const rrnFields = stepEl.querySelectorAll('[data-rrn]');
      for (let j = 0; j < rrnFields.length; j++) {
        const rrnInput      = rrnFields[j];
        const optionalBlock = rrnInput.closest('[data-optional-child]');
        // If this RRN belongs to an optional child block, skip validation when the whole block is empty
        if (optionalBlock) {
          var blockInputs   = optionalBlock.querySelectorAll('input');
          var blockHasData  = false;
          blockInputs.forEach(function (inp) { if (inp.value.trim()) blockHasData = true; });
          if (!blockHasData) continue;
        }
        if (rrnInput.value.replace(/\D/g, '').length !== 11) {
          rrnInput.focus();
          showError('Vul een geldig rijksregisternummer in (11 cijfers).');
          return false;
        }
      }
      return true;
    }

    return true;
  }

  function showError(message) {
    const existing = form.querySelector('.booking-form__error');
    if (existing) existing.remove();

    const el = document.createElement('p');
    el.className = 'booking-form__error px-2 py-1 bg-foreground rounded-lg text-background text-xs font-medium w-fit mt-2';
    el.setAttribute('role', 'alert');
    el.textContent = message;

    form.querySelector('.booking-form__nav').insertAdjacentElement('beforebegin', el);
    setTimeout(function () { el.remove(); }, 4000);
  }

  // ─── BUILD SUMMARY ───────────────────────────────────────

  function buildSummary() {
    if (DEV_DUMMY_SUMMARY) {
      const html =
        '<p class="booking-form__summary-session-title">Dream a Little Dream</p>' +
        '<div class="booking-form__summary-session booking-form__summary-session--traject">' +
          '<p class="booking-form__summary-label">Trajectoverzicht</p>' +
          '<div class="booking-form__summary-traject-sessions">' +
            '<div class="booking-form__summary-traject-session"><span class="booking-form__summary-traject-label">Sessie 1</span><span class="booking-form__summary-traject-date">12 Nov 2026 · 09:30 – 11:30</span></div>' +
            '<div class="booking-form__summary-traject-session"><span class="booking-form__summary-traject-label">Sessie 2</span><span class="booking-form__summary-traject-date">15 Nov 2026 · 09:30 – 11:30</span></div>' +
            '<div class="booking-form__summary-traject-session"><span class="booking-form__summary-traject-label">Sessie 3</span><span class="booking-form__summary-traject-date">1 Dec 2026 · 14:30 – 16:30</span></div>' +
            '<div class="booking-form__summary-traject-session"><span class="booking-form__summary-traject-label">Sessie 4</span><span class="booking-form__summary-traject-date">4 Dec 2026 · 09:30 – 11:30</span></div>' +
            '<div class="booking-form__summary-traject-session"><span class="booking-form__summary-traject-label">Sessie 5</span><span class="booking-form__summary-traject-date">12 Dec 2026 · 09:30 – 11:30</span></div>' +
            '<div class="booking-form__summary-traject-session"><span class="booking-form__summary-traject-label">Sessie 6</span><span class="booking-form__summary-traject-date">22 Dec 2026 · 09:30 – 11:30</span></div>' +
          '</div>' +
          '<p class="booking-form__summary-label mt-3">Locatie</p>' +
          '<p class="booking-form__summary-name booking-form__summary-name--bold">Ekatē Antwerpen</p>' +
        '</div>' +
        '<hr class="booking-form__summary-divider">' +
        '<div class="booking-form__summary-section">' +
          '<p class="booking-form__summary-label">Jouw gegevens</p>' +
          '<div class="booking-form__summary-wrapper">' +
            '<p class="booking-form__summary-name booking-form__summary-name--big">Xander Van der Sijpt</p>' +
            '<div class="booking-form__summary-wrapper">' +
              '<p class="booking-form__summary-detail">test@joule.agency</p>' +
              '<p class="booking-form__summary-detail">+32477785771</p>' +
              '<p class="booking-form__summary-detail">16/07/1990</p>' +
              '<p class="booking-form__summary-detail">90.07.16-123.45</p>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<hr class="booking-form__summary-divider">' +
        '<div class="booking-form__summary-section">' +
          '<p class="booking-form__summary-label">Gegevens van je kinderen</p>' +
          '<div class="booking-form__summary-children">' +
            '<div class="booking-form__summary-child">' +
              '<div class="booking-form__summary-wrapper">' +
                '<p class="booking-form__summary-name booking-form__summary-name--big">Kiddo One</p>' +
                '<div class="booking-form__summary-wrapper">' +
                  '<p class="booking-form__summary-detail">16/07/2003</p>' +
                  '<p class="booking-form__summary-detail">03.07.16-456.78</p>' +
                '</div>' +
              '</div>' +
            '</div>' +
            '<div class="booking-form__summary-child">' +
              '<div class="booking-form__summary-wrapper">' +
                '<p class="booking-form__summary-name booking-form__summary-name--big">Kiddo Two</p>' +
                '<div class="booking-form__summary-wrapper">' +
                  '<p class="booking-form__summary-detail">10/04/2010</p>' +
                  '<p class="booking-form__summary-detail">10.04.10-789.01</p>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      document.getElementById('booking-summary').innerHTML = html;
      document.getElementById('summary-price').textContent = '€85.00';
      return;
    }

    if (!selectedSession) return;

    const rawDate   = new Date(selectedSession.date + 'T00:00:00').toLocaleDateString('nl-BE', {
      weekday: 'long', year: 'numeric', month: 'short', day: 'numeric'
    });
    const dateStr = rawDate.charAt(0).toUpperCase() + rawDate.slice(1);

    const productTitle = (document.querySelector('.session-detail__title') || {}).textContent || '';

    // ── Session / Traject block ──
    let html = productTitle ? '<p class="booking-form__summary-session-title">' + escapeHTML(productTitle.trim()) + '</p>' : '';

    if (selectedSession.isTraject && selectedSession.trajectSessions) {
      // ─ Traject: list all sessions, then location below ─
      html +=
        '<div class="booking-form__summary-session booking-form__summary-session--traject">' +
          '<p class="booking-form__summary-label">Trajectoverzicht</p>' +
          '<div class="booking-form__summary-traject-sessions">';
      selectedSession.trajectSessions.forEach(function (ts, idx) {
        const tsDate = new Date(ts.date + 'T00:00:00').toLocaleDateString('nl-BE', {
          day: 'numeric', month: 'short', year: 'numeric'
        });
        html +=
          '<div class="booking-form__summary-traject-session">' +
            '<span class="booking-form__summary-traject-label">Sessie ' + (idx + 1) + '</span>' +
            '<span class="booking-form__summary-traject-date">' +
              escapeHTML(tsDate.charAt(0).toUpperCase() + tsDate.slice(1)) +
              ' · ' + escapeHTML(ts.timeStart) + ' – ' + escapeHTML(ts.timeEnd) +
            '</span>' +
          '</div>';
      });
      html +=
          '</div>' +
          (selectedSession.location
            ? '<p class="booking-form__summary-label mt-3">Locatie</p>' +
              '<p class="booking-form__summary-name booking-form__summary-name--bold">' + escapeHTML(selectedSession.location) + '</p>'
            : '') +
        '</div>';
    } else {
      // ─ Regular session: two-column flex row ─
      html +=
        '<div class="booking-form__summary-session">' +
          '<div class="booking-form__summary-col">' +
            '<p class="booking-form__summary-label">Datum &amp; Tijd</p>' +
            '<div class="booking-form__summary-wrapper">' +
              '<p class="booking-form__summary-name">' + escapeHTML(dateStr) + '</p>' +
              '<p class="booking-form__summary-name">' + escapeHTML(selectedSession.timeStart) + ' – ' + escapeHTML(selectedSession.timeEnd) + '</p>' +
            '</div>' +
          '</div>' +
          '<div class="booking-form__summary-col">' +
            '<p class="booking-form__summary-label">Locatie</p>' +
            '<p class="booking-form__summary-name">' + escapeHTML(selectedSession.location) + '</p>' +
          '</div>' +
        '</div>';
    }

    // ── Parents ──
    form.querySelectorAll('.booking-form__parent-entry').forEach(function (entry) {
      const i        = entry.dataset.parentIndex;
      const pfx      = 'parent_' + i + '_';
      const fn       = entry.querySelector('[name="' + pfx + 'firstname"]');
      const ln       = entry.querySelector('[name="' + pfx + 'lastname"]');
      const email    = entry.querySelector('[name="' + pfx + 'email"]');
      const phone    = entry.querySelector('[name="' + pfx + 'phone"]');
      const dob      = entry.querySelector('[name="' + pfx + 'dob"]');
      const rrn      = entry.querySelector('[name="' + pfx + 'rrn"]');
      const label    = selectedSession.amountParents === 1 ? 'Jouw gegevens' : 'Ouder ' + i;
      const fullName = ((fn ? fn.value : '') + ' ' + (ln ? ln.value : '')).trim();

      html +=
        '<hr class="booking-form__summary-divider">' +
        '<div class="booking-form__summary-section">' +
          '<p class="booking-form__summary-label">' + escapeHTML(label) + '</p>' +
          '<div class="booking-form__summary-wrapper">' +
            '<p class="booking-form__summary-name booking-form__summary-name--big">' + escapeHTML(fullName) + '</p>' +
            '<div class="booking-form__summary-wrapper">' +
              (email && email.value ? '<p class="booking-form__summary-detail">' + escapeHTML(email.value) + '</p>' : '') +
              (phone && phone.value ? '<p class="booking-form__summary-detail">' + escapeHTML(phone.value) + '</p>' : '') +
              (dob   && dob.value   ? '<p class="booking-form__summary-detail">' + escapeHTML(dob.value)   + '</p>' : '') +
              (rrn   && rrn.value   ? '<p class="booking-form__summary-detail">' + escapeHTML(rrn.value)   + '</p>' : '') +
            '</div>' +
          '</div>' +
        '</div>';
    });

    // ── Child RRN ──
    const childRrnInput = form.querySelector('[name="child_rrn"]');
    if (childRrnInput && childRrnInput.value) {
      html +=
        '<hr class="booking-form__summary-divider">' +
        '<div class="booking-form__summary-section">' +
          '<p class="booking-form__summary-label">Rijksregisternr. kind</p>' +
          '<p class="booking-form__summary-name">' + escapeHTML(childRrnInput.value) + '</p>' +
        '</div>';
    }

    document.getElementById('booking-summary').innerHTML = html;
    document.getElementById('summary-price').textContent = '€' + selectedSession.price;
  }

  // ─── SUBMIT → CLEAR CART + ADD ───────────────────────────

  document.getElementById('btn-submit').addEventListener('click', async function () {
    const btn = this;
    btn.disabled    = true;
    btn.textContent = 'Bezig…';

    const properties = buildCartProperties();

    const variantEl = document.querySelector('[data-variant-id]');
    if (!variantEl) {
      showError('Technische fout: variantId niet gevonden. Herlaad de pagina.');
      btn.disabled = false; btn.textContent = 'Bevestig & betaal';
      return;
    }
    const variantId = variantEl.dataset.variantId;
    const storefrontToken = variantEl.dataset.storefrontToken || '';
    const apiVersion      = variantEl.dataset.apiVersion || '2024-01';

    // ── Real-time availability check ──────────────────────
    if (storefrontToken && selectedSession && selectedSession.handle) {
      try {
        const availRes = await fetch('/api/' + apiVersion + '/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontToken
          },
          body: JSON.stringify({
            query: '{ metaobject(handle: { type: "session_date", handle: ' + JSON.stringify(selectedSession.handle) + ' }) { spotsField: field(key: "spots_taken") { value } capacityField: field(key: "capacity") { value } bookingClosed: field(key: "booking_closed") { value } } }'
          })
        });
        if (availRes.ok) {
          const availData = await availRes.json();
          const mo = availData && availData.data && availData.data.metaobject;
          if (mo) {
            const spotsTaken  = parseInt((mo.spotsField  && mo.spotsField.value)  || '0', 10);
            const capacity    = parseInt((mo.capacityField && mo.capacityField.value) || '0', 10);
            const closed      = mo.bookingClosed && mo.bookingClosed.value === 'true';
            if (closed || (capacity > 0 && spotsTaken >= capacity)) {
              showError('Sorry, deze sessie is intussen volzet. Kies een andere datum.');
              btn.disabled = false; btn.textContent = 'Boek & Betaal';
              return;
            }
          }
        }
      } catch (e) {
        // availability check failed — proceed anyway rather than blocking the customer
        console.warn('[booking-form] availability check failed, proceeding:', e);
      }
    }

    try {
      const clearRes = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      if (!clearRes.ok) throw new Error('cart clear failed');

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1, properties: properties })
      });

      if (addRes.ok) {
        // GDPR consent is required to book, so subscribe the customer to marketing.
        try {
          const emailEl = form.querySelector('[name="parent_1_email"]');
          if (emailEl && emailEl.value) {
            await fetch('https://admin.ekate.workers.dev/api/subscribe', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email: emailEl.value }),
            });
          }
        } catch (e) {
          // non-blocking — proceed to checkout regardless
        }
        window.location.href = '/checkout';
      } else {
        const err = await addRes.json().catch(function () { return {}; });
        showError((err && err.description) || 'Er ging iets mis. Probeer opnieuw.');
        btn.disabled = false; btn.textContent = 'Bevestig & betaal';
      }
    } catch (error) {
      console.error('[booking-form] cart error:', error);
      showError('Er ging iets mis. Probeer opnieuw.');
      btn.disabled = false; btn.textContent = 'Bevestig & betaal';
    }
  });

  // ─── BUILD CART PROPERTIES ───────────────────────────────

  function buildCartProperties() {
    const props = {};

    props['_session_date_handle'] = selectedSession.handle;
    props['Datum'] = new Date(selectedSession.date + 'T00:00:00').toLocaleDateString('nl-BE', {
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
    });
    props['Tijdstip'] = selectedSession.timeStart + ' – ' + selectedSession.timeEnd;
    props['Locatie']  = selectedSession.location;

    // Parents
    form.querySelectorAll('.booking-form__parent-entry').forEach(function (entry) {
      const i     = entry.dataset.parentIndex;
      const pfx   = 'parent_' + i + '_';
      const label = selectedSession.amountParents === 1 ? 'Ouder' : 'Ouder ' + i;

      const fn    = entry.querySelector('[name="' + pfx + 'firstname"]');
      const ln    = entry.querySelector('[name="' + pfx + 'lastname"]');
      const dob   = entry.querySelector('[name="' + pfx + 'dob"]');
      const email = entry.querySelector('[name="' + pfx + 'email"]');
      const phone = entry.querySelector('[name="' + pfx + 'phone"]');
      const rrn   = entry.querySelector('[name="' + pfx + 'rrn"]');

      props[label + ' naam']          = (fn ? fn.value : '') + ' ' + (ln ? ln.value : '');
      props[label + ' geboortedatum'] = dob   ? dob.value   : '';
      if (email) props[label + ' e-mail']    = email.value;
      if (phone) props[label + ' telefoon']  = phone.value;
      props['_' + label.toLowerCase().replace(' ', '_') + '_rrn'] = rrn ? rrn.value.replace(/[.\-]/g, '') : '';
    });

    // Child RRN
    const childRrnEl = form.querySelector('[name="child_rrn"]');
    if (childRrnEl && childRrnEl.value) {
      props['_child_1_rrn'] = childRrnEl.value.replace(/[.\-]/g, '');
    }

    props['_gdpr_consent']   = 'true';
    props['_gdpr_timestamp'] = new Date().toISOString();

    const toIso = (date, time) => {
      const [h, m] = time.split(':');
      return date.replace(/-/g, '') + 'T' + h + m + '00';
    };

    if (selectedSession.isTraject && selectedSession.trajectSessions) {
      const ts = selectedSession.trajectSessions;
      props['_is_traject'] = 'true';
      props['_trajectsessies'] = ts.map(function (s) {
        const d = new Date(s.date + 'T00:00:00');
        const label = d.toLocaleDateString('nl-BE', { day: 'numeric', month: 'short', year: 'numeric' });
        return label + ' ' + s.timeStart + '–' + s.timeEnd;
      }).join('|');
      const first = ts[0];
      props['_traject_first_start'] = toIso(first.date, first.timeStart);
      props['_traject_first_end']   = toIso(first.date, first.timeEnd);
    } else {
      props['_start_iso'] = toIso(selectedSession.date, selectedSession.timeStart);
      props['_end_iso']   = toIso(selectedSession.date, selectedSession.timeEnd);
    }

    return props;
  }

  // ─── UTILS ───────────────────────────────────────────────

  function escapeHTML(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ─── INIT ────────────────────────────────────────────────

  showStep(1);
});
